/**
 * @file
 * Attaches the behaviors for news landing.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.newsLanding = {
    attach(context) {
      nakedFormSelect('select', context, {
        keywordSearch: {
          on: true,
          placeholder: 'Enter keyword'
        }
      });

      $('.news-landing__form--category #edit-category', context).change(
        function () {
          $(this).closest('form').submit();
        }
      );
    }
  };
})(Drupal);
